import { MatDatepickerIntl } from '@angular/material/datepicker';

export class FrenchDatepickerIntl extends MatDatepickerIntl {
  override calendarLabel = 'Calendrier';
  override openCalendarLabel = 'Ouvrir le calendrier';
  override closeCalendarLabel = 'Fermer le calendrier';
  override prevMonthLabel = 'Mois précédent';
  override nextMonthLabel = 'Mois suivant';
  override prevYearLabel = 'Année précédente';
  override nextYearLabel = 'Année suivante';
  override prevMultiYearLabel = 'Périodes précédentes';
  override nextMultiYearLabel = 'Périodes suivantes';
  override switchToMonthViewLabel = 'Choisir une date';
  override switchToMultiYearViewLabel = 'Choisir un mois ou une année';
  override startDateLabel = 'Date de début';
  override endDateLabel = 'Date de fin';
  override comparisonDateLabel = 'Date de comparaison';
}
